import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

export default function PlatformIndexPage() {
  const navigate = useNavigate();
  useEffect(() => {
    navigate("/platform/dashboard", { replace: true });
  }, [navigate]);
  return null;
}
